// @ts-check
// Guarda das telas de Campanhas (spec-2.0.0 seção 4.10, [BASE 2.6]; contrato 09 de campanhas base): toda página das
// áreas é montada dentro dela. Sem a flag da tela (shared/navigation/screen-access.js) ou sem leitura do card (o público
// das campanhas e dos fluxos é o card), mostra "sem acesso" em vez de deixar a tela pedir dados que o servidor recusa.
import { html } from 'htm/preact';
import { hasCurrentPermissionFlag, objectsByNameSingular } from '../../data/metadata-store.js';
import { canReadObjectRecords } from '../../lib/permissions.js';
import { canOpenCampaignScreen } from '../../lib/campaign-links.js';
import { CampaignsNoAccess } from './campaigns-no-access.js';

/** @typedef {import('./campaigns-no-access.js').CampaignScreenGuardKey} CampaignScreenGuardKey */

/** @param {{ screenKey: CampaignScreenGuardKey, children?: any }} props */
export function CampaignScreenGuard({ screenKey, children }) {
  const cardObject = objectsByNameSingular.value.get('enrollmentOpportunity');
  const canReadCards = Boolean(cardObject) && canReadObjectRecords(cardObject);
  if (!canOpenCampaignScreen(screenKey, hasCurrentPermissionFlag, canReadCards)) return html`<${CampaignsNoAccess} screenKey=${screenKey} />`;
  return children ?? null;
}
